export default {
  CONNECTIVITY_CHECK_TIMEOUT: +import.meta.env.VITE_CONNECTIVITY_CHECK_TIMEOUT,
  VITE_API_URL: import.meta.env.VITE_API_URL,
  VITE_DASHBOARD_URL: import.meta.env.VITE_DASHBOARD_URL,
  VITE_DISABLED_FEATURES: import.meta.env.VITE_DISABLED_FEATURES
    ? import.meta.env.VITE_DISABLED_FEATURES.split(",")
    : [],
  VITE_MAIN_LOOP_INTERVAL: Number(import.meta.env.VITE_MAIN_LOOP_INTERVAL),
  VITE_SILENCED_CASE_TIME_TO_STALE: import.meta.env
    .VITE_SILENCED_CASE_TIME_TO_STALE,
  VITE_TWIAGE_API_HEALTH_URL: import.meta.env.VITE_TWIAGE_API_HEALTH_URL,
};
